export default {
      id: "i-search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/sprite.svg#i-search",
      toString: function () {
        return this.url;
      }
    }